import {PageNav} from "@main/components/page-nav";
import axios from "@main/axios";
import listTemplate from "@partials/test-list.handlebars";

export class TestList {
    constructor(el) {
        this.el = el;
        this.id =  this.el.dataset.id;
        this.url =  this.el.dataset.url;
        this.searchInput =  this.el.querySelector(".js-test-list-search-input");
        this.searchBtn =  this.el.querySelector(".js-test-list-search-btn");
        this.listBody =  this.el.querySelector(".js-test-list-body");
        this.params =  this.el.querySelectorAll(".js-test-list-param");
        this.nav = new PageNav(this.el.querySelector(".js-page-nav-test-list"));
        this.initEvents();
    }

    initEvents() {
        this.el.addEventListener("loadList", (e) => {
            const resetNav = e.detail?.resetNav || false;
            this.loadTestsList(resetNav);
        });

        this.searchInput.addEventListener("keypress", (e) => {
            const keyCode = e.code || e.key;
            if (keyCode === "Enter") {
                e.preventDefault();
                this.loadTestsList(true);
            }
        });

        this.searchBtn.addEventListener("click", (e) => {
            e.preventDefault();
            this.loadTestsList(true);
        });
    }

    loadTestsList(resetNav = false) {
        this.data = {
            id: this.id,
            page: resetNav? 1 : this.nav.getCurrentPage()
        };
        this.prepareParams();
        this.prepareSearch();
        this.sendData();
    }

    prepareParams() {
        this.params.forEach((param) => {
            const name = param.dataset.name;
            const current = param.querySelector(".current");
            if (current) {
                const value = current.dataset.value;
                if (value) {
                    this.data[name] = value;
                }
            }
        });
    }

    prepareSearch() {
        if (this.searchInput.value) {
            this.data[this.searchInput.name] = this.searchInput.value;
        }
    }

    sendData = async () => {
        try {
            if (this.el.classList.contains("waiting")) {
                return;
            }
            this.el.classList.add("waiting");
            const params = this.data;
            const response = await axios({
                url: this.url,
                params,
                method: "get",
            });
            this.el.classList.remove("waiting");
            if (!response?.data) {
                this.showError("Что-то пошло не так...\nПожалуйста, перезагрузите страницу.");
                return;
            }
            if (response.data.success) {
                if (response.data.data && response.data.data.items && response.data.data.items.length > 0) {
                    this.listBody.innerHTML = listTemplate({items: response.data.data.items});
                    this.el.dispatchEvent(new CustomEvent("setArchiveCheckEvents"));
                    this.nav.build(response.data.data.pages, this.data.page);
                } else {
                    this.listBody.innerHTML = response.data.message
                }
            } else {
                this.showError(response.data.message);
            }
        } catch (error) {
            this.showError(error);
            this.el.classList.remove("waiting");
        }
    }

    showError(error) {
        this.listBody.innerHTML = "<div class='test-list__error'>" + error + "</div>";
    }
}

document.querySelectorAll(".js-test-list").forEach(elem => new TestList(elem));
